export default __webpack_public_path__ + "static/garamond-medium-670cc59b2a8d212a27ccc1063ec3b6e3.eot";